import en from './en-US';

export default {
  ...en,
};
